import React, { Component } from 'react';
import { Steps, Button } from 'antd';
import { FormattedMessage, injectIntl  } from 'react-intl';
import EmailReportTypeForm from './EmailReportTypeForm'
import ConsumablesStep2 from './ConsumablesStep2'
import MetersReportStep2 from './MetersReportStep2'
import ChangeDeviceConsumablesStep2 from './ChangeDeviceConsumablesStep2'
import DocumentPrintedStep2 from './DocumentPrintedStep2'
import ChangeDeviceStatusStep2 from './ChangeDeviceStatusStep2'
import PrintedJobsStep2 from './PrintedJobsStep2'
import CommonReportStep2 from './CommonReportStep2'
import EmailReportScheduleStep from './EmailReportScheduleStep'
import {REPORT_PERIOD, RECEIVER_EMAIL, REPORT_ID} from '../utils/constants'

const { Step } = Steps;

const reportScheduleCommon = [
    5, //"Period.EveryHour"
    1, //"Period.EveryDay"
    2, //"Period.EveryWeek"
    3, //"Period.EveryMonth"
];

const reportScheduleEvent = [
    7, //"Period.ProgramEvent"
];

const reportScheduleJob = [
    0, //"Period.Job"
];

class EmailReportsWizard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            disableNext : false
        };

        this.reportsCallbacks = {
            setReportType : (type) => this.setReportType(type),
            getReportType : () => this.getReportType(),
            setStoreValue : (report, name, value) => this.setStoreValue(report, name, value),
            getStoreValue : (report, name) => this.getStoreValue(report, name)
        };

        this.steps_length = 3;
        this.reports_steps = {};
        this.reports_steps["Report.Consumables"] = [
            {
              title: <FormattedMessage id="Report.Type"/>,
              content: <EmailReportTypeForm callbacks = {this.reportsCallbacks} report = {this.props.report}/>,
            },
            {
              title: <FormattedMessage id="Report.Consumables.SupplyLimit"/>,
              content: <ConsumablesStep2 callbacks = {this.reportsCallbacks} report = {this.props.report}/>,
            },
            {
              title: 'Email',
              content: <EmailReportScheduleStep callbacks = {this.reportsCallbacks} 
              onDisableNext = {(value) => this.onDisableNext(value)} 
              report = {this.props.report}
              schedule = {reportScheduleCommon}/>,
            },
          ];

          this.reports_steps["Report.Meters"] = [
            {
              title: <FormattedMessage id="Report.Type"/>,
              content: <EmailReportTypeForm callbacks = {this.reportsCallbacks} report = {this.props.report}/>,
            },
            {
              title: <FormattedMessage id="Report.Meters.Printers"/>,
              content: <MetersReportStep2 callbacks = {this.reportsCallbacks} report = {this.props.report}/>,
            },
            {
              title: 'Email',
              content: <EmailReportScheduleStep callbacks = {this.reportsCallbacks} 
              onDisableNext = {(value) => this.onDisableNext(value)} 
              report = {this.props.report}
              schedule = {reportScheduleCommon}/>,
            },
          ];

          this.reports_steps["Report.ChangeDeviceConsumables"] = [
            {
              title: <FormattedMessage id="Report.Type"/>,
              content: <EmailReportTypeForm callbacks = {this.reportsCallbacks} report = {this.props.report}/>,
            },
            {
              title: <FormattedMessage id="Report.Meters.Printers"/>,
              content: <ChangeDeviceConsumablesStep2 callbacks = {this.reportsCallbacks} report = {this.props.report}/>,
            },
            {
              title: 'Email',
              content: <EmailReportScheduleStep callbacks = {this.reportsCallbacks} 
              onDisableNext = {(value) => this.onDisableNext(value)} 
              report = {this.props.report}
              schedule = {reportScheduleEvent}/>,
            },
          ];

          this.reports_steps["Report.ChangeDeviceStatus"] = [
            {
              title: <FormattedMessage id="Report.Type"/>,
              content: <EmailReportTypeForm callbacks = {this.reportsCallbacks} report = {this.props.report}/>,
            },
            {
              title: <FormattedMessage id="Report.Meters.Printers"/>,
              content: <ChangeDeviceStatusStep2 callbacks = {this.reportsCallbacks} report = {this.props.report}/>,
            },
            {
              title: 'Email',
              content: <EmailReportScheduleStep callbacks = {this.reportsCallbacks} 
              onDisableNext = {(value) => this.onDisableNext(value)} 
              report = {this.props.report}
              schedule = {reportScheduleEvent}/>,
            },
          ];

          this.reports_steps["Report.DocumentPrinted"] = [
            {
              title: <FormattedMessage id="Report.Type"/>,
              content: <EmailReportTypeForm callbacks = {this.reportsCallbacks} report = {this.props.report}/>,
            },
            {
              title: <FormattedMessage id="LeftMenu.SubMenu.settings"/>,
              content: <DocumentPrintedStep2 callbacks = {this.reportsCallbacks} report = {this.props.report}/>,
            },
            {
              title: 'Email',
              content: <EmailReportScheduleStep callbacks = {this.reportsCallbacks} 
              onDisableNext = {(value) => this.onDisableNext(value)} 
              report = {this.props.report}
              schedule = {reportScheduleJob}/>,
            },
          ];

          this.reports_steps["Report.PrintedJobs"] = [
            {
              title: <FormattedMessage id="Report.Type"/>,
              content: <EmailReportTypeForm callbacks = {this.reportsCallbacks} report = {this.props.report}/>,
            },
            {
              title: <FormattedMessage id="LeftMenu.SubMenu.settings"/>,
              content: <PrintedJobsStep2 callbacks = {this.reportsCallbacks} report = {this.props.report}/>,
            },
            {
              title: 'Email',
              content: <EmailReportScheduleStep callbacks = {this.reportsCallbacks} 
              onDisableNext = {(value) => this.onDisableNext(value)} 
              report = {this.props.report}
              schedule = {reportScheduleCommon}/>,
            },
          ];

          this.reports_steps["Report.Summary"] = [
            {
              title: <FormattedMessage id="Report.Type"/>,
              content: <EmailReportTypeForm callbacks = {this.reportsCallbacks} report = {this.props.report}/>,
            },
            {
              title: <FormattedMessage id="LeftMenu.SubMenu.settings"/>,
              content: <CommonReportStep2 type = "summary" callbacks = {this.reportsCallbacks} report = {this.props.report}/>,
            },
            {
              title: 'Email',
              content: <EmailReportScheduleStep callbacks = {this.reportsCallbacks} 
              onDisableNext = {(value) => this.onDisableNext(value)} 
              report = {this.props.report}
              schedule = {reportScheduleCommon}/>,
            },
          ];

          this.reports_steps["Report.Detailed"] = [
            {
              title: <FormattedMessage id="Report.Type"/>,
              content: <EmailReportTypeForm callbacks = {this.reportsCallbacks} report = {this.props.report}/>,
            },
            {
              title: <FormattedMessage id="LeftMenu.SubMenu.settings"/>,
              content: <CommonReportStep2 type = "detailed" callbacks = {this.reportsCallbacks} report = {this.props.report}/>,
            },
            {
              title: 'Email',
              content: <EmailReportScheduleStep callbacks = {this.reportsCallbacks} 
              onDisableNext = {(value) => this.onDisableNext(value)} 
              report = {this.props.report}
              schedule = {reportScheduleCommon}/>,
            },
          ];

          this.store = {};
    }

    setReportType(type)
    {
        this.store["report_type"] = type;
    }

    getReportType()
    {
        if (typeof this.store["report_type"] === 'undefined')
        {
            return undefined;
        }

        return this.store["report_type"];
    }

    setStoreValue(report, name, value)
    {
        if (typeof this.store[report] === "undefined")
        {
            this.store[report] = {};
            if (this.props.report === undefined || Object.keys(this.props.report).length === 0)
            {
                this.store[report][REPORT_ID] = 0;
            }
            else
            {
                this.store[report][REPORT_ID] = this.props.report.id;
                this.store[report][RECEIVER_EMAIL] = this.props.report.email;
                this.store[report][REPORT_PERIOD] = this.props.report.period;

            }
        }

        var report_data = this.store[report];
        report_data[name] = value;
    }

    getStoreValue(report, name)
    {
        var report_data = this.store[report];
        if (report_data !== undefined)
            return report_data[name];
        else
            return undefined;
    }

    onDisableNext(value)
    {
        this.setState({disableNext : value});
    }

    render() {
        const report_type = this.getReportType();
        var steps = this.reports_steps[report_type === undefined ? "Report.Consumables" : report_type];

        var report_title;
        if (this.state.current > 0 && report_type !== undefined)
        {
            report_title = this.props.intl.formatMessage({id: report_type});
        }

        return (
            <>
                <Steps current={this.state.current}>
                    {steps.map((item, index) => {
                        return <Step key={item.title} title={index === 0 && report_title !== undefined ? report_title : item.title}/>
                    })}
                </Steps>
                <div className="steps-content">{steps[this.state.current].content}</div>
                <div className="steps-action">
                <Button className="button-row" onClick={() => this.props.onClose()}>
                    <FormattedMessage id="Cancel"/>
                </Button>
                {this.state.current > 0 && (
                    <Button className="button-row" onClick={() => this.setState({disableNext: false, current: this.state.current - 1})}>
                        <FormattedMessage id="Previous"/>
                    </Button>
                    )}
                    {this.state.current < this.steps_length - 1 && (
                    <Button className="button-row" type="primary" disabled = {this.state.disableNext} onClick={() => this.setState({current: this.state.current + 1})}>
                        <FormattedMessage id="Next"/>
                    </Button>
                    )}
                    {this.state.current === this.steps_length - 1 && (
                    <Button className="button-row" type="primary" disabled = {this.state.disableNext} onClick={() => this.props.onFinish(this.store)}>
                        <FormattedMessage id="Done"/>
                    </Button>
                    )}
                </div>
            </>
        );
      }
}

export default injectIntl(EmailReportsWizard, {
    withRef: true,
  });